import { Skeleton } from '@/shared/ui/Skeleton'

import styles from './RatingSummary.module.scss'

export const RatingSummarySkeleton = () => (
	<div className={styles.reviewsCard} aria-hidden="true">
		<div className={styles.reviewsBody}>
			<div className={styles.ratingHeadline}>
				<div className={styles.ratingValue}>
					<Skeleton width={48} height={26} borderRadius={8} />
					<Skeleton width={24} height={24} borderRadius={12} />
				</div>
				<div className={styles.ratingStars}>
					<Skeleton width={96} height={16} borderRadius={8} />
					<Skeleton width={104} height={16} borderRadius={8} />
				</div>
			</div>

			<div className={styles.ratingBars}>
				{Array.from({ length: 5 }).map((_, index) => (
					<div className={styles.ratingBarRow} key={index}>
						<Skeleton width={20} height={10} borderRadius={5} />
						<Skeleton height={4} borderRadius={4} />
						<Skeleton width={14} height={10} borderRadius={5} />
					</div>
				))}
			</div>
		</div>

		<Skeleton height={40} borderRadius={20} />
	</div>
)
